import { CONCIL_LIST } from '@/modules/Screening/pages/ContextualScreen/constants'

export const phoneRegExp = /^\([1-9]{2}\) 9?[2-9]\d{3}-\d{4}$/

export const strongPasswordRegExp =
  /^(?=.*[A-Z])(?=.*[!@#$&%><*])(?=.*\d)(?=.*[a-z]).{8,}$/

export const mediumPasswordRegExp = new RegExp(
  '' +
    // mininum: 1 upper and 1 lower, 1 number and length 8,
    /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d).{8,}/.source +
    // mininum: 1 upper and 1 lower, 1 special char and length 8,
    /|(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$&%><*]).{8,}/.source +
    // mininum: 1 special char, 1 number and length 8,
    /|(?=.*[!@#$&%><*])(?=.*\d).{8,}/.source +
    // mininum: 1 upper and 1 lower, 1 symbol and 1 number
    /|(?=.*[A-Z])(?=.*[a-z]).{1,}(?=.*[!@#$&%><*]).{1,}(?=.*\d).{1,}$/.source,
)

export const hasMin8LettersRegExp = /.{8,}/

export const hasEspecialCharacterRegExp = /(?=.*[!@#$&%><*]).+/

export const hasNumberRegExp = /(?=.*\d).+/

export const hasLowerAndUppercaseLettersRegExp = /(?=.*[a-z])(?=.*[A-Z]).+/

/**
 * Regex para identificar tipo do profissional e, opcionalmente, um ID após uma barra.
 * Exemplo de uso: "MEDICO/123" ou "MEDICO"
 */
export const professionalTypeWithOptionalIdRegExp = (
  professionalType: string,
) => new RegExp(`${professionalType}(?:/(\\d+))?`, 'i')

export function parseMagicLinkUrl(url: string) {
  const patterns = [
    // /atendimento-agendado/categoria/<tipoProfissional>/<idProfissional>/<tokenAtendimento>
    {
      regex:
        /.*atendimento-agendado\/categoria\/([^/]+)\/(\d+)\/([a-zA-Z0-9]+)/,
      get: (m: RegExpMatchArray) => ({
        council: CONCIL_LIST[m[1].toUpperCase()],
        professionalId: Number(m[2]),
        specialtyId: null,
      }),
    },
    // /atendimento-agendado/categoria/<tipoProfissional>/<idProfissional>
    {
      regex: /.*atendimento-agendado\/categoria\/([^/]+)\/(\d+)/,
      get: (m: RegExpMatchArray) => ({
        council: CONCIL_LIST[m[1].toUpperCase()],
        professionalId: Number(m[2]),
        specialtyId: null,
      }),
    },
    // /atendimento-agendado/especialidade/encaixe/<tipoProfissional>/<idEspecialidade>
    {
      regex: /.*atendimento-agendado\/especialidade\/encaixe\/([^/]+)\/(\d+)/,
      get: (m: RegExpMatchArray) => ({
        council: CONCIL_LIST[m[1].toUpperCase()],
        professionalId: null,
        specialtyId: Number(m[2]),
      }),
    },
    // /atendimento-agendado-psicologo/busca-profissional/perfil-profissional/<idProfissional>
    {
      regex:
        /.*atendimento-agendado-psicologo\/busca-profissional\/perfil-profissional\/(\d+)/,
      get: (m: RegExpMatchArray) => ({
        council: CONCIL_LIST.PSICOLOGO,
        professionalId: Number(m[1]),
        specialtyId: null,
      }),
    },
    // /atendimento-agendado/preferencia/busca-profissional/<tipoProfissional>/<idEspecialidade>
    {
      regex:
        /.*atendimento-agendado\/preferencia\/busca-profissional\/([^/]+)\/(\d+)/,
      get: (m: RegExpMatchArray) => ({
        council: CONCIL_LIST[m[1].toUpperCase()],
        professionalId: null,
        specialtyId: Number(m[2]),
      }),
    },
    // /atendimento-agendado/preferencia/busca-profissional/<tipoProfissional>
    {
      regex: /.*atendimento-agendado\/preferencia\/busca-profissional\/([^/]+)/,
      get: (m: RegExpMatchArray) => ({
        council: CONCIL_LIST[m[1].toUpperCase()],
        professionalId: null,
        specialtyId: null,
      }),
    },
    // /atendimento-agendado/preferencia/<tipoProfissional>
    {
      regex: /.*atendimento-agendado\/preferencia\/([^/]+)/,
      get: (m: RegExpMatchArray) => ({
        council: CONCIL_LIST[m[1].toUpperCase()],
        professionalId: null,
        specialtyId: null,
      }),
    },
    // /atendimento-agendado/<tipoProfissional>/especialidades
    {
      regex: /.*atendimento-agendado\/([^/]+)\/especialidades/,
      get: (m: RegExpMatchArray) => ({
        council: CONCIL_LIST[m[1].toUpperCase()],
        professionalId: null,
        specialtyId: null,
      }),
    },
    // /atendimento-agendado/categoria/medico/<idProfissional>
    {
      regex: /.*atendimento-agendado\/categoria\/medico\/(\d+)/,
      get: (m: RegExpMatchArray) => ({
        council: CONCIL_LIST.MEDICO,
        professionalId: Number(m[1]),
        specialtyId: null,
      }),
    },
  ]

  for (const pattern of patterns) {
    const match = url.match(pattern.regex)
    if (match) return pattern.get(match)
  }
  return { council: null, professionalId: null, specialtyId: null }
}
